import { Directive, OnDestroy } from '@angular/core';

import { fromEvent, Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil, throttleTime } from 'rxjs/operators';
import { nodeObserverCleanup } from './change-observer';
import { doOnMutationType } from './lib';
import { isBrowser } from './w-universal';

@Directive()
/*
use to unsubscribe automatically
*/
// tslint:disable-next-line: directive-class-suffix
export abstract class WRxBase implements OnDestroy {
    destruction = new Subject<void>();
    debounceInterval = 200;
    updated = new Subject<void>();
    isBrowser = isBrowser;
    autoUnsubscribe = takeUntil(this.destruction);

    ngOnDestroy(): void {
        this.destruction.next();
        this.destruction.complete();
        nodeObserverCleanup();
    }
    fromEvent(el: Window | Document | HTMLElement, eventName: string) {
        return fromEvent(el, eventName).pipe(takeUntil(this.destruction), debounceTime(this.debounceInterval));
    }
    throttle<T>(o: Observable<T>, interval?: number): Observable<T> {
        return o.pipe(takeUntil(this.destruction), throttleTime(interval ?? this.debounceInterval));
    }
    runOnMutation(node: Element, config: any, callback: () => void, types: MutationRecordType[] = []) {
        doOnMutationType(node, config,
            types).pipe(takeUntil(this.destruction), debounceTime(this.debounceInterval))
            .subscribe(callback);
    }
}


